/**
 * Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {Schema} from 'simpli-web-sdk'
import RenderNumber from '@/components/render/RenderNumber.vue'
import DeliveryMonthResponse from '@/model/response/DeliveryMonthResponse'
import moment from 'moment'

export default (model: DeliveryMonthResponse): Schema => ({

    data: {
        content: moment(model.data).format('MMM/YY'),
    },

    qtdComOcorrencia: {
        content: {
          component: RenderNumber,
          props: {
            number: model.qtdComOcorrencia || '0',
          },
        },
        textContent: model.qtdComOcorrencia || '0',
      },

  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia || '0',
      },
    },
    textContent: model.qtdSemOcorrencia || '0',
  },

    qtdDevolvidas: {
        content: {
          component: RenderNumber,
          props: {
            number: model.qtdDevolvidas || '0',
          },
        },
        textContent: model.qtdDevolvidas || '0',
    },

    qtdTotal: {
        content: {
            component: RenderNumber,
            props: {
                number: model.qtdTotal || '0',
            },
        },
        textContent: model.qtdTotal || '0',
    },

})
